import { Component, OnInit } from '@angular/core';
import {AuthServiceService} from './auth-service.service';
import {Router} from '@angular/router';
import {User} from '../models/user';
import {AngularFireAuth} from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
// import {FirebaseListObservable} from 'angularfire2/database-deprecated';
import {AngularFireDatabase} from 'angularfire2/database';
import {Observable, Subject} from 'rxjs';
import * as firebase from 'firebase';
import {ProfilComponent} from '../profil/profil.component';
import {ApiServiceService} from '../Service/api-service.service';
import {Person} from '../Person';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  email: string;
  password: string;

  u = {} as User;
  // users: FirebaseListObservable<User[]> = null;
  userId: string;
  t: Person;
  d: Person[];

  Lists$: Observable<object[]>;
  private searchTerms = new Subject<string>();


  constructor(public authenticationService: AuthServiceService, public route: Router,
              private angularFireAuth: AngularFireAuth, public apiServiceService: ApiServiceService) {

  }

  search(term: string): void {
    this.searchTerms.next(term);
  }
  createUser(user: User): Promise<any> {
    console.log('createUser method ! ');


    // this.u.favCandidate = '';
    return firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
        .then( newUser => {
          firebase.database()
              .ref(`/users/${firebase.auth().currentUser.uid}`)
              .set(user);

          console.log('succesfully user created!');
          this.route.navigate(['/profil']);
        });
  }
  signOut() {
    this.authenticationService.SignOut();
  }

  ngOnInit(): void {
    this.Lists$ = this.searchTerms.pipe(
        // wait 300ms after each keystroke before considering the term
        debounceTime(300),

        // ignore new term if same as previous term
        distinctUntilChanged(),

        // switch to new search observable each time the term changes
        switchMap((term: string) => this.apiServiceService.getResultSearch(term)),
    );
  }

  selectThisFavCandidate(userFavCandidate) {
    firebase.database()
        .ref(`/users/${firebase.auth().currentUser.uid}`)
        .set(userFavCandidate);
  }
}
